'use client';

import type { PropsWithChildren } from 'react';
import type { InteractionType } from '~/model/InteractionType';
import type { QuestionType } from '~/model/QuestionType';
import { useCallback, useEffect, useState } from 'react';
import { fetchThreadQuestionsCollection } from '@/app/actions/server/threads';
import { MainLoader } from '@/app/components/Loader';
import { ProgressProvider, useApiErrorContext } from '@/app/components/Provider';
import { RequestStatus, useRequestState } from '~/hooks/request/useRequestState';
import { FormProvider } from '../FormProvider';
import { UserSelector } from '../UserSelector';

export const ThreadWrapper = ({ children, interaction }: PropsWithChildren<{ interaction: InteractionType }>) => {
  const { setError } = useApiErrorContext();

  const { status, startRequest, handleError, handleSuccess } = useRequestState();

  const [questions, setQuestions] = useState<QuestionType[]>();

  const fetchQuestions = useCallback(async () => {
    startRequest();

    try {
      const fetchedQuestions = await fetchThreadQuestionsCollection(interaction.sections);
      setQuestions(fetchedQuestions.flat());
      handleSuccess();
    } catch (error) {
      setError(error);
      handleError();
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [interaction.sections]);

  useEffect(() => {
    fetchQuestions();
  }, [fetchQuestions]);

  if (status === RequestStatus.PENDING || !questions) {
    return <MainLoader />;
  }

  return (
    <FormProvider
      conclusions={null}
      interaction={interaction}
      questions={questions}
      sections={null}
    >
      <ProgressProvider total={0}>
        <UserSelector interaction={interaction}>
          {children}
        </UserSelector>
      </ProgressProvider>
    </FormProvider>
  );
};
